// @flow
import { itemClicked, trackEvent } from '../analyticsHelpers';

const activityLocationServiceArea = 'SP : Service Area';
const activityLocationManage = 'SP : Manage Service Area';

export default {
  page: {
    name: activityLocationManage,
    properties: {
      title: activityLocationManage,
      path: '/app/store/[[serviceProviderId]]/service-areas',
    },
  },
  elements: {
    'service-area-upsell-card-container': (itemClicked(activityLocationServiceArea, 'Premium upgrade learn more'): any),
    'edit-service-area-button-yes': (itemClicked(activityLocationServiceArea, 'Edit Service Area'): any),
    'edit-service-area-edit-button': (itemClicked(activityLocationServiceArea, 'Edit Service Area'): any),
    'reset-service-area-button-yes': (itemClicked(activityLocationManage, 'Reset Service Area - Reset'): any),
    'reset-service-area-button-no': (itemClicked(activityLocationManage, 'Reset Service Area - Cancel'): any),
    'service-area-reset': (trackEvent('Modal Fired', activityLocationManage, 'Reset Service Area'): {|click: {|name: string, properties: any|}|}),
  },
};



// WEBPACK FOOTER //
// ./src/app/browser/service-areas/serviceAreaMapAnalytics.js